import { combineReducers } from 'redux';

// Reducers
import busyIndicatorReducer from '../busy-indicator/busy-indicator-reducer';
import consoleReducer from '../console/reducers/console-reducer';
import toastReducer from '../console/reducers/toast-reducer';

const CombinedReducers = combineReducers({
    busyIndicatorReducer,
    consoleReducer,
    toast: toastReducer
});

export default CombinedReducers;



// WEBPACK FOOTER //
// ./containers/app/combined-reducers.js